import { RootObject, Content } from '../../type';
import './style.less';
const Banner = (props: RootObject["Banner"]) => {
  const {
    backImg,
    headeImg,
    txtImg,
    content,
    lSymbolImg,
    rSymbolImg,
    descTxt
  } = props;
  return (
    <>
      <div className='p-p-foundathon-banner' style={{ background: `url(${backImg})` }}>
        <div className='p-p-foundathon-banner-wrapper'>
          <div className='p-p-foundathon-banner-title-img-wrapper'>
            <div className='p-p-foundathon-banner-title-img-wrapper-back' style={{ background: `url(${headeImg})` }} />
          </div>
          <div className='p-p-foundathon-banner-txt-img-wrapper'>
            <div className='p-p-foundathon-banner-txt-img-wrapper-back' style={{ background: `url(${txtImg})` }} />
          </div>
          <div className='p-p-foundathon-banner-btn-list'>
            {
              content.map((item: Content, index: number) => {
                return (
                  <a className='p-p-foundathon-banner-btn-list-btn' href={item.link} target='_blank' rel='noreferrer' key={index}>
                    <div className='p-p-foundathon-banner-btn-list-btn-name'>{item.title ?? ''}</div>
                  </a>
                )
              })
            }
          </div>
        </div>
      </div>

      <div className='p-p-foundathon-banner-content'>
        <div className='p-p-foundathon-banner-content-l-symbol'>
          <div className='p-p-foundathon-banner-content-l-symbol-back' style={{ background: `url(${lSymbolImg})` }}></div>
        </div>


        <div className='p-p-foundathon-banner-content-txt'>
          {descTxt ?? ''}
        </div>
        <div className='p-p-foundathon-banner-content-r-symbol'>
          <div className='p-p-foundathon-banner-content-r-symbol-back' style={{ background: `url(${rSymbolImg})` }}></div>
        </div>
      </div>
    </>
  )
}

export default Banner;